var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{attrs:{"title":_vm.date}},[(!_vm.fromNow)?_c('span',[_vm._v(" "+_vm._s(_vm.formatted)+" ")]):_vm._e(),(_vm.fromNow)?_c('span',[_vm._v(" "+_vm._s(_vm.formattedUpdated)+" ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }